import {
  Component, EventEmitter, Input, Output
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export interface IDataInterface {
  type?: string,
  settings?: ISettingsInterface
}
export interface ISettingsInterface {
  capsule?: string
  heading?: string
  content?: any
  buttons?: Array<IButtonsInterface>
  image?: string
  disclaimer?: any
}

export interface IButtonsInterface {
  label?: string
  link?: string
}

@Component({
  selector: 'app-product-cross-content',
  templateUrl: './product-cross-content.component.html',
  styleUrls: ['./product-cross-content.component.scss']
})
export class ProductCrossContentComponent {
  @Input() data!: IDataInterface;
  @Output() startQuoteEvent = new EventEmitter<string>();

  pageContent!: any;
  disclaimerContent!: any;

  constructor(private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.pageContent = this.domSanitizer.bypassSecurityTrustHtml(this.data.settings?.content);
    this.disclaimerContent = this.domSanitizer.bypassSecurityTrustHtml(this.data.settings?.disclaimer);
  }
}
